import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Portfolio from "./components/portfolio/Portfolio";
import Projects from "./components/projects/Projects";
import ProjectDetails from "./components/project-details/ProjectDetails";
import Services from "./components/services/Services";
import Testimonials from "./components/testimonials/Testimonials";
import ThemeToggle from "./components/theme-toggle/ThemeToggle";
import LanguageSelector from "./components/language-selector/LanguageSelector";

import "./index.css";

const App = () => {
  return (
    <ThemeProvider>
      <ThemeToggle />
      <LanguageSelector />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Nav />
              <About />
              <Experience />
              <Services />
              <Portfolio />
              <Testimonials />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route path="/projects" element={<Projects />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
